import React, { useEffect, useState } from "react";
import { AppBar, Dialog, Grid, IconButton, Toolbar, Typography } from "@mui/material";
import MaterialTable from "@material-table/core";
import { ExportCsv } from "@material-table/exporters";

import { getSemanaDePosgrado } from "../../../../services/crudSemanaDePosgrado";

import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import moment from 'moment';
import Swal from "sweetalert2";
import { SemanaDePosgradoAdmin } from "../../SemanaDePosgradoAdmin";
import CloseIcon from '@mui/icons-material/Close';



const SemanaDePosgradoTable = (props) => {

    const { year } = props;

    const [showAdmin, setShowAdmin] = useState(false);

    // Columnas para presentar en la tabla
    const columns = [
        { title: 'Nombres', field: 'estNombres' },
        { title: 'Apellido Paterno', field: 'estApellidoPaterno' },
        { title: 'Apellido Materno', field: 'estApellidoMaterno' },
        { title: 'Correo', field: 'estCorreo' },
        // { 
        //     title: 'Fecha de registro', 
        //     field: 'fechaRegistro', 
        //    render: (rowData) => moment(rowData.fechaRegistro).format('DD/MMM/YYYY HH:mm')  
        // },
    ];

    console.log({year});
    // state para almacenar la data 
    const [records, setRecords] = useState(props.records);
    // const [records, setRecords] = useState([]);
    
    // Columnas para exportar toda la tabla
    const columnsToExport = [
        { title: 'Apellido Paterno', field: 'estApellidoPaterno' },
        { title: 'Apellido Materno', field: 'estApellidoMaterno' },
        { title: 'Nombres', field: 'estNombres' },
        { title: 'Sexo', field: 'estSexo' },
        { title: 'Fecha de nacimiento', field: 'estFechaNac' },
        { title: 'País', field: 'estPais' },
        { title: 'Estado', field: 'estEstado' },
        { title: 'Nacionalidad', field: 'estNacionalidad' },
        { title: 'Correo', field: 'estCorreo' },
        { title: 'Institución de procedencia', field: 'partInstProcedencia' },
        { title: 'Programa', field: 'partPrograma' },
        { title: 'Año', field: 'partYear' },
        { title: 'Modalidad', field: 'partModalidad' },
        { title: 'Arte científico', field: 'partArteCient' },
        { title: 'Pronaces', field: 'partPronaces' },
        { title: 'Titulo', field: 'resTitulo' },
        { title: 'Director', field: 'resDirector' },
        { title: 'Fecha de registro', field: 'fechaRegistro' },
    ];

    // Nombre para mostrar
    const tableTitle = "Semana de Posgrado";
   
    const deleteItem = async(item) => {
        console.log('delete', item);

        Swal.fire({
            title: `¿Eliminar el registro de ${item.estNombres}?`,
            text: "Esta acción no se puede deshacer.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
        }).then(async(result) => {
            if (result.isConfirmed) {
                
                const getRecords = await getSemanaDePosgrado();
                const recordsFiltered = (getRecords.data).filter( 
                    record => record.fechaRegistro.includes('2023')
                );
                setRecords(recordsFiltered);
            }
        })

    }

    const exportData = () => {
        const timeNow = moment().format('YYYYMMDDTHHmmss').toString();
        ExportCsv(columnsToExport, records, `${tableTitle}_${timeNow}`)
    }

    const refreshData = async() => {
        const getRecords = await getSemanaDePosgrado();
        setRecords(getRecords.data);
        setShowAdmin(false);
    }

    const handleCloseAdmin = () => {
        // console.log(e);
        setShowAdmin(false);
    }


    useEffect(() => {
      
        const getData = async() => {
            const getRecords = await getSemanaDePosgrado();
            
            if (getRecords.exito === 0) {
                console.log('No se pudo recuperar la info');
                return false;
            }
            // Se establece el state con los registros recuperados
            // setRecords(getRecords.data);

            // Filtrar lo que se muestra en SemanaDePosgradoTable
            const recordsFiltered = (getRecords.data).filter( 
                record => record.fechaRegistro.includes('2023')
            );
            console.log({ recordsFiltered });
            setRecords(recordsFiltered);


        }

        getData();

    }, [  ])
    
    return (
        <>
            <Grid container >
                {/* Boton de agregar */}
                {/* <Grid item xs={12}>
                    <Button variant="outlined" onClick={ () => handleShowAdmin() }  sx={{ mb: 2 }}>
                        <AddIcon />
                    </Button>
                </Grid> */}
                <Grid item xs={12}>
                    <MaterialTable
                        columns={ columns }
                        data={ records }
                        title={''}
                        // title={tableTitle}
                        actions={[
                            // {
                            //     icon: EditIcon,
                            //     tooltip: 'Editar',
                            //     onClick: (_, rowData) => editItem(rowData)
                            // },
                            {
                                icon: DeleteIcon,
                                tooltip: 'Eliminar',
                                onClick: (_, rowData) => deleteItem(rowData)
                            },
                        ]}
                        options={{ 
                            actionsColumnIndex: -1, 
                            exportMenu: [{
                                label: 'Exportar CSV',
                                exportFunc: () => exportData()
                            }]
                        }}
                        localization= {{ 
                            header: { actions: '' },
                            toolbar: { 
                                searchPlaceholder: 'Buscar', 
                                exportTitle: 'Exportar' 
                            },                    
                            pagination: { 
                                labelRowsPerPage: '', 
                                labelRowsSelect: 'registros' 
                            },                    
                        }}
                    />
                </Grid>
                <Dialog
                    fullScreen
                    open={showAdmin}
                >
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseAdmin}
                            aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                Agregar registro
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <SemanaDePosgradoAdmin 
                        parentCallback={refreshData} 
                    />
                </Dialog>
            </Grid>
        </>
    );
};

export default SemanaDePosgradoTable;
